const enum ConsigneState {
    None = 0,
    Urgent = 1,
    Remaining = 2,
    Info = 3,
    Completed = 4,
    Cancelled = 5,
}

export default ConsigneState;